import { Provider } from '@angular/core';
import { EX_CONTROL_CONFIG } from 'src/webid/4.0/projects/types/src/lib/configuration/tokens';
import { ExControlConfig } from 'types';

const ExControlConfigData: ExControlConfig = {
    type: 'slider',
};

export default [{ provide: EX_CONTROL_CONFIG, useFactory: () => ExControlConfigData }] as Array<Provider>;
